import { useEffect } from "react";
import { card_visitActions } from "../actions";
import { cardVisitConstants } from "../constants";
import { useDispatch, useSelector } from "react-redux";

export const useCardVisitHook = ({
    workspace_id
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if(workspace_id){
        const onSuccess = (response) => {
            const { data: visits } = response.data;
            console.log(visits);
            console.log("Workspace_id", workspace_id);

            dispatch({ type: cardVisitConstants.GET_CARD_VISITS, payload: visits })
        }

        dispatch(card_visitActions.getCardVisits({workspace_id, onSuccess}));
    }   

  }, [workspace_id]); 

  return {}
};